import BaseField from "./BaseField";
import SelectItem from "./SelectItem";

export class DateSelectField extends BaseField {
    constructor(props) {
        super(props);
        this.state = {
            day: null,
            month: null,
            year: null,
        }
        this.handleDateUpdate = this.handleDateUpdate.bind(this);
    }

    componentDidMount(){
        let date = new Date();
        this.setState({
            day: date.getDay(),
            month: date.getMonth(),
            year: date.getFullYear(),
        })
    }

    InitYear(){
        let currentDate = new Date();
        let year = currentDate.getFullYear();
        let years = [];
        for (let i = year; i >= 1900; i--){
            years.push(<SelectItem
                key={i}
                value={i}
                title={i}
            />)
        }
        return years;
    }

    InitMonth(){
        let months = [];
        for(let i = 1; i <= 12; i++){
            let monthvalue = i - 1;
            months.push(<SelectItem
                key={i}
                value={monthvalue}
                title={this.getMonth(i)}
            />)
        }
        return months;
    }

    InitDays(){
        let month = this.state.month;
        let year = this.state.year;
        let maxDaysInMonth = new Date(year, month, 0).getDate();
        let days = [];
        for(let i = 1; i <= maxDaysInMonth; i++){
            days.push(<SelectItem
                key={i}
                value={i}
                title={i}
            />)
        }
        return days;
    }

    getMonth(index){
        let date = new Date();
        date.setDate(1);
        date.setMonth(index - 1);
        return date.toLocaleString('de', {month: "short"})
    }

    handleDateUpdate(type, value){
        let month = this.state.month;
        let year = this.state.year;
        let day = this.state.day;
        switch(type) {
            case 'day': {
                day = value;
                this.setState({
                    day: value,
                })
                break;
            }
            case 'month': {
                month = value;
                this.setState({
                    month: value,
                })
                break;
            }
            case 'year': {
                year = value;
                this.setState({
                    year: value,
                })
                break;
            }
        }

        let date = new Date();
        date.setMonth(month);
        date.setFullYear(year);
        date.setDate(day);
        this.props.collectData(this.props.id, date);
    }

    render(){
        let dayID = this.props.Label + '_Day';
        let monthID = this.props.Label + '_Month';
        let yearID = this.props.Label + '_Year';
        return (
            <div className={this.props.Columns}>
                <div className="field date" id={this.props.id}>
                    <label className="">
                        {this.renderLabelText()}
                    </label>
                    <div className="row">
                        <div className="col-4">
                            <select className="pseudodate day form-control" value={this.props.value} id={dayID} placeholder={this.props.PlaceholderDay} onChange={(e) => {this.handleDateUpdate('day', e.target.value)}}>
                                {this.InitDays()}
                            </select>
                        </div>
                        <div className="col-4">
                            <select className="pseudodate month form-control" value={this.props.value} id={monthID} placeholder={this.props.PlaceholderMonth} onChange={(e) => {this.handleDateUpdate('month', e.target.value)}}>
                                {this.InitMonth()}
                            </select>
                        </div>
                        <div className="col-4">
                            <select className="pseudodate year form-control" value={this.props.value} id={yearID} placeholder={this.props.PlaceholderYear} onChange={(e) => {this.handleDateUpdate('year', e.target.value)}}>
                                {this.InitYear()}
                            </select>
                        </div>
                    </div>
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default DateSelectField;
